(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('ClientCreditsEditModalController', ClientCreditsEditModalController);

        ClientCreditsEditModalController.$inject = ['$filter', '$uibModalInstance', 'ClientService', 'InvoicesService', 'SellerService', 'clientCredits', 'credit', 'toastr'];

    function ClientCreditsEditModalController($filter, $uibModalInstance, ClientService, InvoicesService, SellerService, clientCredits, credit, toastr) {
        var vm = this;

        // Form
        vm.search           = null;
        vm.user_id          = null;
        vm.seller_id        = null; 
        vm.sellerSelected   = null;
        vm.date             = null;
        vm.currency         = null;
        vm.total            = null;
        vm.description      = null;
        vm.contact_email    = null;
        vm.contact_name     = null;
        vm.dateOptions      = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            locale: {
                format: 'DD/MM/YYYY',
                cancelLabel: 'Close'
            }
        };

        // Methods
        vm.getCurrencies    = getCurrencies;
        vm.getSellers       = getSellers;
        vm.sellers          = null; 
        vm.getLastInvoice   = getLastInvoice;
        vm.formatDate       = formatDate;
        vm.searchClients    = searchClients;

        // Modal
        vm.ok               = ok;
        vm.cancel           = cancel;

        function formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        }

        activate();

        function activate() {            
            vm.getCurrencies();                    
            vm.search = credit.email;
            vm.searchClients('activate');
            vm.currency = credit.currency;
            vm.total = parseFloat(credit.total).toFixed(2);
            vm.description = credit.description;
            vm.seller_id = credit.seller_id;
            vm.contact_name = credit.contact_name;
            vm.contact_email = credit.contact_email;     
            vm.getSellers();       
        }

        function ok () {
            let query = {};
            query['user_id'] = vm.user_id;
            query['seller_id'] = vm.sellerSelected.id;
            query['contact_name'] = vm.contact_name;
            query['contact_email'] = vm.contact_email;
            query['currency'] = vm.currency;
            query['total'] = vm.total;
            query['description'] = vm.description;
            // query['date'] = vm.date;
            ClientService.updateCredit(credit.id, query).then(function(response, status) {
                if(response.status !== 200) {
                    toastr.error("An error ocurred on update this Client Credit");
                } else {
                    toastr.success("Client Credit successfully updated!");
                    clientCredits.getByFilter();
                }
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
            $uibModalInstance.close();
        }

        function getCurrencies () {
            InvoicesService.getPaymentCurrencies().then(function (response) {
                vm.currencies = response.data;
            });
        }

        function getSellers () {
            SellerService.getAll().then(function(response) {
                vm.sellers = response.data;
                vm.sellerSelected = $filter('filter')(vm.sellers, {id: vm.seller_id})[0];
            }).catch(function(err) {
            });
        }

        function getLastInvoice () {
            InvoicesService.getLastInvoice(vm.user_id).then(function (response) {
                vm.contact_name = response.data.contact_name;
                vm.contact_email = response.data.contact_email;
                vm.seller_id = response.data.seller_id;
                vm.sellerSelected = {
                    id: response.data.seller_id,
                    name: response.data.seller_name
                };
            });
        }

        function searchClients (type = 'form') {
            let query = {};
            query['search'] = vm.search;
            ClientService.listClients(query).then(function(response) {
                vm.users = response.data;
                if(type == 'activate') {
                    vm.user_id = vm.users[0].id;
                }
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();